const r = (x) => /\d/.test(x), u = ({
  phoneBeforeInput: x,
  phoneAfterInput: c,
  phoneAfterFormatted: l,
  cursorPositionAfterInput: s,
  leftOffset: k = 0,
  deletion: D
}) => {
  if (s < k)
    return k;
  if (!x)
    return l.length;
  const b = D === "backward";
  if (s === 0 && c.length > 0 && l.length > 0) {
    if (b) return 0;
    for (let i = 0; i < l.length; i += 1) {
      const g = l[i];
      if (g && r(g))
        return i;
    }
    return l.length;
  }
  if (c.length < x.length && c.length === 1)
    return l.length;
  let e = null;
  for (let i = s - 1; i >= 0; i -= 1) {
    const g = c[i];
    if (g && r(g)) {
      e = i;
      break;
    }
  }
  if (e === null)
    return s !== 0 ? s : l.length;
  let h = 0;
  for (let i = 0; i < e; i += 1) {
    const g = c[i];
    g && r(g) && (h += 1);
  }
  b && (h -= 1);
  let n = 0, C = 0;
  for (let i = 0; i < l.length; i += 1) {
    n += 1;
    const g = l[i];
    if (g && r(g) && (C += 1), C === h + 1)
      break;
  }
  for (; n < l.length; ) {
    const i = l[n];
    if (i && r(i)) break;
    n += 1;
  }
  return b && (n += 1), n;
};
export {
  u as getCursorPosition
};
